// components/DialogProvider.tsx
import React, { createContext, useState, useCallback, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import ErrorDialogController from './error-dialog-controller';
// type
import { DialogOptions } from '../types/dialogOptions';

/**
 * DialogContext
 */
export const DialogContext = createContext({
    showDialog: (_: DialogOptions) => {},
});

/**
 * ダイアログプロバイダー
 * @param param
 * @returns 
 */
export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [dialog, setDialog] = useState<DialogOptions | null>(null);

    /**
     * ダイアログ表示
     */
    const showDialog = useCallback((options: DialogOptions) => {
        setDialog(options);
    }, []);

    /**
     * 初期表示
     */
    useEffect(() => {
        ErrorDialogController.register(showDialog);
    }, [showDialog]);

    /**
     * 🟡 閉じる
     */
    const handleClose = () => {
        dialog?.onClose?.();
        setDialog(null);
    };

    // dialog本体
    return (
        <DialogContext.Provider value={{ showDialog }}>
            {children}
            <Dialog open={!!dialog} onClose={handleClose}>
                <DialogTitle>{dialog?.title || '通知'}</DialogTitle>
                <DialogContent>
                <Typography>{dialog?.message}</Typography>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} autoFocus>閉じる</Button>
                </DialogActions>
            </Dialog>
        </DialogContext.Provider>
    );
};